module.exports = __webpack_public_path__ + "img/codepen.2d25e52d.svg";